/* Stock/delivery status — re-renders ONLY on variant change.
   On page load the status is already server-rendered (Liquid), so this does
   nothing until the user picks a different variant. Mirrors the legacy logic. */
(function () {
  function getStatusCode(inStock, edt) {
    if (inStock) return '0';
    if (edt > 0 && edt < 80) return 'EXPECTED_ON';
    if (edt === 89) return '89';
    if (edt === 98) return '98';
    if (edt === 97) return '97';
    if (edt >= 80) return '90';
    return '0';
  }
  function getColor(inStock, edt) {
    if (inStock || (edt > 0 && edt < 80)) return 'green';
    if (edt === 89 || edt === 90) return 'orange';
    if (edt >= 80) return 'red';
    return 'green';
  }
  function icon(color) {
    var fill = color === 'red' ? '#b22222' : (color === 'orange' ? '#ff6600' : '#28a745');
    if (color === 'red') {
      return '<svg fill="' + fill + '" height="1.5em" viewBox="0 0 512 512" width="1.5em" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M256 8C119.043 8 8 119.043 8 256s111.043 248 248 248 248-111.043 248-248S392.957 8 256 8zm112 276H144c-13.255 0-24-10.745-24-24s10.745-24 24-24h224c13.255 0 24 10.745 24 24s-10.745 24-24 24z"></path></svg>';
    }
    return '<svg fill="' + fill + '" height="1.5em" viewBox="0 0 512 512" width="1.5em" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-277.314 97.941 184-184c4.686-4.686 4.686-12.284 0-16.971l-28.284-28.284c-4.686-4.686-12.284-4.686-16.971 0L216 284.117l-70.059-70.058c-4.686-4.686-12.284-4.686-16.971 0l-28.284 28.284c-4.686 4.686-4.686 12.284 0 16.971l112 112c4.686 4.686 12.284 4.686 16.971 0z"></path></svg>';
  }
  function expectedDate(edt) {
    var d = new Date(Date.now() + edt * 86400000);
    function p(n) { return n < 10 ? '0' + n : '' + n; }
    return p(d.getDate()) + '.' + p(d.getMonth() + 1) + '.' + d.getFullYear();
  }
  function deliveryMsgDK() {
    var rules = [
      { cut: 22 * 60, before: 'Modtag din pakke i morgen - Bestil før 22:00', after: 'Modtag din pakke på tirsdag - Bestil inden kl. 21:00 i morgen' },
      { cut: 21 * 60, before: 'Modtag din pakke i morgen - Bestil før 21:00', after: 'Modtag din pakke på onsdag - Bestil inden kl. 21:00 i morgen' },
      { cut: 21 * 60, before: 'Modtag din pakke i morgen - Bestil før 21:00', after: 'Modtag din pakke på torsdag - Bestil inden kl. 21:00 i morgen' },
      { cut: 21 * 60, before: 'Modtag din pakke i morgen - Bestil før 21:00', after: 'Modtag din pakke på fredag - Bestil inden kl. 21:00 i morgen' },
      { cut: 21 * 60, before: 'Modtag din pakke i morgen - Bestil før 21:00', after: 'Modtag din pakke på lørdag - Bestil inden kl. 21:00 i morgen' },
      { cut: 21 * 60, before: 'Modtag din pakke i morgen - Bestil før 21:00', after: 'Modtag din pakke på søndag - Bestil inden kl. 22:00 i morgen' },
      { cut: 22 * 60, before: 'Modtag din pakke i morgen - Bestil før 22:00', after: 'Modtag din pakke på mandag - Bestil inden kl. 22:00 i morgen' }
    ];
    var parts = Object.fromEntries(
      new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Copenhagen', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false })
        .formatToParts(new Date()).map(function (p) { return [p.type, p.value]; })
    );
    var dayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    var idx = dayMap[parts.weekday];
    var hour = parseInt(parts.hour, 10); if (hour === 24) hour = 0;
    var mins = hour * 60 + parseInt(parts.minute, 10);
    var r = rules[idx];
    return mins < r.cut ? r.before : r.after;
  }
  function texts(code, edt) {
    switch (code) {
      case 'EXPECTED_ON': return { first: 'Bestilt', second: 'Forventes på lager: ' + expectedDate(edt) };
      case '89': return { first: 'På fjernlager', second: 'Forventet levering 5-10 dage' };
      case '97': return { first: 'Udgået produkt', second: '' };
      case '98': return { first: 'Ikke på lager', second: 'Ubekræftet leveringsdato.' };
      case '90': return { first: 'På fjernlager', second: 'Forventet levering 15-18 dage' };
      default: return { first: 'På lager', second: deliveryMsgDK() };
    }
  }
  function render(el, inStock, edt) {
    var code = getStatusCode(inStock, edt);
    var color = getColor(inStock, edt);
    var t = texts(code, edt);
    el.className = 'stock-status stock-status--' + color;
    el.innerHTML =
      '<span class="stock-status__icon">' + icon(color) + '</span>' +
      '<span class="stock-status__text"><span class="stock-status__first">' + t.first + '</span>' +
      (t.second ? '<span class="stock-status__second">' + t.second + '</span>' : '') + '</span>';
  }
  function getData() {
    var s = document.querySelector('[data-stock-status-data]');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }
  document.addEventListener('on:variant:change', function (e) {
    var variant = e.detail && e.detail.variant;
    var el = document.querySelector('[data-stock-status]');
    if (!variant || !el) return;
    var data = getData();
    var info = data && data[variant.id];
    if (!info) return; // unknown variant → keep server-rendered value
    render(el, !!info.in_stock, parseInt(info.edt, 10) || 0);
  });
})();
